import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    Text,
    VStack,
    useColorModeValue
} from '@chakra-ui/react';

function ExportPdfModal({ isOpen, onClose, onDownload }) {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = async () => {
        if (!email) {
            // Simple validation
            alert('Please enter your email.');
            return;
        }

        setIsLoading(true);
        await onDownload(email);
        setIsLoading(false);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay
                bg='blackAlpha.300'
                backdropFilter='blur(10px)'
            />
            <ModalContent bg={useColorModeValue('white', 'gray.800')}>
                <ModalHeader>Export PDF Report</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <Text fontSize="sm" color="gray.500">
                            To download the complete PDF report, please enter your email below.
                        </Text>
                        <FormControl isRequired>
                            <FormLabel>Corporate Email</FormLabel>
                            <Input
                                placeholder="your.name@company.com"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>

                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="brand"
                        onClick={handleDownload}
                        isLoading={isLoading}
                        loadingText="Generating PDF..."
                    >
                        Download PDF
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default ExportPdfModal;
